"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
function cov_14bk9h1kbu() {
  var path = "/home/node/project/src/_config.js";
  var hash = "86ec665be70a62bc92fca6ae184073480b2ed727";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/node/project/src/_config.js",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 26
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "1": {
        start: {
          line: 18,
          column: 18
        },
        end: {
          line: 18,
          column: 76
        }
      },
      "2": {
        start: {
          line: 18,
          column: 41
        },
        end: {
          line: 18,
          column: 75
        }
      },
      "3": {
        start: {
          line: 20,
          column: 27
        },
        end: {
          line: 20,
          column: 92
        }
      },
      "4": {
        start: {
          line: 20,
          column: 50
        },
        end: {
          line: 20,
          column: 91
        }
      },
      "5": {
        start: {
          line: 22,
          column: 21
        },
        end: {
          line: 22,
          column: 82
        }
      },
      "6": {
        start: {
          line: 22,
          column: 44
        },
        end: {
          line: 22,
          column: 81
        }
      },
      "7": {
        start: {
          line: 25,
          column: 35
        },
        end: {
          line: 28,
          column: 1
        }
      },
      "8": {
        start: {
          line: 31,
          column: 25
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "9": {
        start: {
          line: 35,
          column: 13
        },
        end: {
          line: 40,
          column: 1
        }
      },
      "10": {
        start: {
          line: 42,
          column: 13
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "11": {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 43,
          column: 33
        }
      },
      "12": {
        start: {
          line: 46,
          column: 12
        },
        end: {
          line: 46,
          column: 30
        }
      },
      "13": {
        start: {
          line: 46,
          column: 19
        },
        end: {
          line: 46,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 18,
            column: 11
          },
          end: {
            line: 18,
            column: 12
          }
        },
        loc: {
          start: {
            line: 18,
            column: 18
          },
          end: {
            line: 18,
            column: 76
          }
        },
        line: 18
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 30
          },
          end: {
            line: 18,
            column: 31
          }
        },
        loc: {
          start: {
            line: 18,
            column: 41
          },
          end: {
            line: 18,
            column: 75
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 12
          }
        },
        loc: {
          start: {
            line: 20,
            column: 27
          },
          end: {
            line: 20,
            column: 92
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 39
          },
          end: {
            line: 20,
            column: 40
          }
        },
        loc: {
          start: {
            line: 20,
            column: 50
          },
          end: {
            line: 20,
            column: 91
          }
        },
        line: 20
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 22,
            column: 14
          },
          end: {
            line: 22,
            column: 15
          }
        },
        loc: {
          start: {
            line: 22,
            column: 21
          },
          end: {
            line: 22,
            column: 82
          }
        },
        line: 22
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 22,
            column: 33
          },
          end: {
            line: 22,
            column: 34
          }
        },
        loc: {
          start: {
            line: 22,
            column: 44
          },
          end: {
            line: 22,
            column: 81
          }
        },
        line: 22
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 42,
            column: 13
          },
          end: {
            line: 42,
            column: 14
          }
        },
        loc: {
          start: {
            line: 42,
            column: 22
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 42
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 46,
            column: 12
          },
          end: {
            line: 46,
            column: 13
          }
        },
        loc: {
          start: {
            line: 46,
            column: 19
          },
          end: {
            line: 46,
            column: 30
          }
        },
        line: 46
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "86ec665be70a62bc92fca6ae184073480b2ed727"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_14bk9h1kbu = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_14bk9h1kbu();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable arrow-parens */
/* global localStorage */

/*
 * Use localStorage for caching by default. This can be overridden to use any
 * synchronous or asynchronous caching mechanism. For example, using AsyncStorage
 * with React Native, you would override the default storage in your app by including
 * the following code.
 *    Api.defaults.storage = {
 *      getItem: AsyncStorage.getItem,
 *
 *      setItem: AsyncStorage.setItem,
 *
 *      removeItem: AsyncStorage.removeItem,
 *    }
 */
var asyncLocalStorage = (cov_14bk9h1kbu().s[0]++, {
  getItem: function getItem(key) {
    cov_14bk9h1kbu().f[0]++;
    cov_14bk9h1kbu().s[1]++;
    return new _promise["default"](function (resolve) {
      cov_14bk9h1kbu().f[1]++;
      cov_14bk9h1kbu().s[2]++;
      return resolve(localStorage.getItem(key));
    });
  },
  setItem: function setItem(key, value) {
    cov_14bk9h1kbu().f[2]++;
    cov_14bk9h1kbu().s[3]++;
    return new _promise["default"](function (resolve) {
      cov_14bk9h1kbu().f[3]++;
      cov_14bk9h1kbu().s[4]++;
      return resolve(localStorage.setItem(key, value));
    });
  },
  removeItem: function removeItem(key) {
    cov_14bk9h1kbu().f[4]++;
    cov_14bk9h1kbu().s[5]++;
    return new _promise["default"](function (resolve) {
      cov_14bk9h1kbu().f[5]++;
      cov_14bk9h1kbu().s[6]++;
      return resolve(localStorage.removeItem(key));
    });
  }
});
var cacheGlobalCategoryFilters = (cov_14bk9h1kbu().s[7]++, {
  enabled: true,
  key: 'globalCategoryFilters'
});

// Current user is expected to be cached and cannot be disabled
var cacheCurrentUser = (cov_14bk9h1kbu().s[8]++, {
  key: 'current_user'
});
var config = (cov_14bk9h1kbu().s[9]++, {
  rootUrl: '',
  storage: asyncLocalStorage,
  cacheGlobalCategoryFilters: cacheGlobalCategoryFilters,
  cacheCurrentUser: cacheCurrentUser
});
cov_14bk9h1kbu().s[10]++;
var init = function init(obj) {
  cov_14bk9h1kbu().f[6]++;
  cov_14bk9h1kbu().s[11]++;
  config = _objectSpread(_objectSpread({}, config), obj);
};
cov_14bk9h1kbu().s[12]++;
var get = function get(key) {
  cov_14bk9h1kbu().f[7]++;
  cov_14bk9h1kbu().s[13]++;
  return config[key];
};
var _default = exports["default"] = {
  init: init,
  get: get
};